import { create } from 'zustand';
import { getApiClient } from '../lib/apiClientInstance';
import type { AuthStore, LoginPayload, LoginResponse } from '../types';

export const useAuthService = create<AuthStore>((set) => ({
  // Initial state
  loginLoading: false,
  loginError: null,
  loginData: null,
  socialLoginLoading: false,
  socialLoginError: null,

  // Login API call
  loginApi: async (data: LoginPayload) => {
    try {
      set({ loginLoading: true, loginError: null });
      const client = getApiClient();

      const response = await client.post<{ data: LoginResponse }>('/auth/login', data);
      const loginData = response.data;

      set({
        loginLoading: false,
        loginData,
      });

      // Return the unwrapped LoginResponse (matches type definition)
      return loginData;
    } catch (err: any) {
      const errorMessage = err?.message || 'Login failed';
      set({
        loginLoading: false,
        loginError: errorMessage,
      });
      throw err;
    }
  },

  // Verify auth cookie after OAuth callback
  verifyAuthCookie: async () => {
    try {
      set({ socialLoginLoading: true, socialLoginError: null });
      const client = getApiClient();

      // Call verify-cookie endpoint which reads HTTP-only cookie
      const response = await client.post<{ data: LoginResponse }>('/auth/verify-cookie', {});
      const loginData = response.data;

      set({
        socialLoginLoading: false,
        loginData,
      });

      return loginData;
    } catch (err: any) {
      const errorMessage = err?.message || 'Cookie verification failed';
      set({
        socialLoginLoading: false,
        socialLoginError: errorMessage,
      });
      throw err;
    }
  },

  // Reset auth state
  resetAuthApi: () => {
    set({
      loginError: null,
      loginData: null,
      socialLoginError: null,
    });
  },
}));
